import React, { FC, ReactNode } from 'react';
import { InView } from 'react-intersection-observer';

import { trackSegmentTrackEvent } from '../../lib/segment-analytics';
import usePageViewId from '../../lib/segment/usePageViewId';

interface SegmentImpressionProps {
  children: ReactNode;
  className?: string;
  eventName: string;
  eventProps?: Record<string, any>;
}

const SegmentImpression: FC<SegmentImpressionProps> = ({
  children,
  className,
  eventName,
  eventProps = {},
}) => {
  const pageViewId = usePageViewId();
  const handleViewChange = (inView: boolean) => {
    if (inView) {
      trackSegmentTrackEvent(eventName, pageViewId, eventProps);
    }
  };

  return (
    <InView className={className} onChange={handleViewChange} triggerOnce>
      {children}
    </InView>
  );
};

export default SegmentImpression;
